import { render, staticRenderFns } from "./ConfigureGroup.vue?vue&type=template&id=132300ea&scoped=true&"
import script from "./ConfigureGroup.vue?vue&type=script&lang=ts&"
export * from "./ConfigureGroup.vue?vue&type=script&lang=ts&"
import style0 from "./ConfigureGroup.vue?vue&type=style&index=0&id=132300ea&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "132300ea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('132300ea')) {
      api.createRecord('132300ea', component.options)
    } else {
      api.reload('132300ea', component.options)
    }
    module.hot.accept("./ConfigureGroup.vue?vue&type=template&id=132300ea&scoped=true&", function () {
      api.rerender('132300ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/forms/groups/ConfigureGroup.vue"
export default component.exports